import { GET_ALL_DEPARTMENTS } from '../types';

const initialState = {
  departments: [],
};

export default function Department(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_DEPARTMENTS:
      return {
        ...state,
        departments: action.payload,
      };
    default:
      return state;
  }
}